import React from "react";
import { Section, Overline, H1, Lead, H2 } from "@/components/ui-kit";

export default function About() {
  return (
    <>
      <Section className="pt-12 md:pt-20 pb-8 md:pb-10">
        <Overline>About</Overline>
        <H1 className="mt-5 max-w-4xl">Built for creative real estate execution.</H1>
        <Lead className="mt-5 md:mt-7 max-w-3xl">
          Brightside Capital Ventures LLC is a veteran-led real estate investment and acquisitions company focused on
          finding practical, creative, and profitable solutions for property owners, investors, and buyers across the
          Sacramento region.
        </Lead>
      </Section>

      <Section className="py-10 md:py-16" dataTestId="about-what-we-do">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12">
          <div>
            <H2 className="text-2xl">What we do</H2>
            <p className="text-neutral-300 mt-5 leading-relaxed">
              We focus on Sacramento-area real estate with value-add potential: single-family homes, 2-4 unit properties,
              small apartment buildings, ADUs, garage conversions, and infill opportunities. Our work blends acquisitions,
              renovation, repositioning, and creative deal structures to fit the situation in front of us.
            </p>
          </div>
          <div>
            <H2 className="text-2xl">Founder positioning</H2>
            <ul className="mt-5 space-y-3 text-sm text-neutral-300">
              {[
                "Veteran-led",
                "Real estate investor / operator background",
                "Prior multifamily ownership experience",
                "Sales, finance, and property management background",
                "Disciplined underwriting and creative deal structuring",
                "Long-term relationship orientation over transactional thinking",
              ].map((t) => <li key={t} className="border-l border-[#C19B6C]/50 pl-4 py-1">{t}</li>)}
            </ul>
          </div>
        </div>
      </Section>
    </>
  );
}
